import { useTranslation } from 'react-i18next';

import { MplButton } from '../../../atoms/MplButton/MplButton';
import {
	CompleteAnim,
	ErrorAnim,
	FailedAnim,
} from '../../../molecules/Animations';
import { MplModal } from '../../MplModal/MplModal';
import type { TEmailChangeResult } from '../ProfileManager';

type TEmailChangeModalsProps = {
	onCloseModal: () => void;
	onBackToEmailEdit: () => void;
	emailChangeModalType: TEmailChangeResult;
};

export const EmailChangeModals = ({
	onCloseModal,
	onBackToEmailEdit,
	emailChangeModalType,
}: TEmailChangeModalsProps) => {
	const { t } = useTranslation(['profile']);
	const generateModal = () => {
		switch (emailChangeModalType) {
			case 'success':
				return (
					<MplModal
						open
						testId="changeEmailModalSuccess"
						title={t('edit_email.modals.success_title')}
						icon={<CompleteAnim />}
						onClose={onCloseModal}
						buttons={
							<MplButton fullWidth onClick={onCloseModal}>
								{t('button.close')}
							</MplButton>
						}
					/>
				);
			case 'failure':
				return (
					<MplModal
						open
						testId="changeEmailModalFailure"
						title={t('edit_email.modals.failure_title')}
						icon={<FailedAnim />}
						onClose={onCloseModal}
						buttons={
							<MplButton fullWidth onClick={onCloseModal}>
								{t('button.close')}
							</MplButton>
						}
					/>
				);
			case 'expired':
				return (
					<MplModal
						open
						testId="changeEmailModalExpired"
						title={t('edit_email.modals.expired_title')}
						content={t('edit_email.modals.expired_content')}
						icon={<ErrorAnim />}
						onClose={onCloseModal}
						buttons={
							<>
								<MplButton fullWidth onClick={onBackToEmailEdit}>
									{t('button.enter_email_again')}
								</MplButton>
								<MplButton fullWidth onClick={onCloseModal} variant="outlined">
									{t('button.close')}
								</MplButton>
							</>
						}
					/>
				);
			default:
				return '';
		}
	};
	return <>{generateModal()}</>;
};
